window.sfDocumentReady(['route-supplier-special-conditions-index'], () => {
  // initialize data table
  window.setupDatatable('.js-datatable', 'asc');

  // trigger form submission upon confirmation, when delete link is clicked
  $(document).on('click', '#delete_supplier_special_condition_link', function() {
    const shouldDelete = confirm(
      'Are you sure you want to delete this condition?'
    );
    if (shouldDelete) {
      $(this)
        .parents('form:first')
        .trigger('submit');
    } else {
      return false;
    }
  });
});

window.sfDocumentReady([
  'route-application-view',
  'route-application-residential-view',
  'route-application-car-view'
], () => {
  // trigger form submission upon confirmation, when delete link is clicked
  $(document).on('click', '.settlement-condition__item .item__toolbar__delete', function () {
    const shouldDelete = confirm(
      'Are you sure you want to delete this condition?'
    )

    if (shouldDelete) {
      window.httpDelete($(this).data('delete'), {
        success: () => {
          $(this).closest('.settlement-condition__item').remove()
        }
      })
    } else {
      return false
    }
  })
})

